<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_3356_730)">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M20 2.49992C21 1.99995 22 3 21.5 3.99999L13.8527 21.4417C13.4379 22.3727 12.0765 22.0698 12.0765 21.0465L10 14L2.93126 12.1308C1.9261 12.1308 1.63559 10.7247 2.55465 10.308L20 2.49992ZM13.5 18L12 13.5C12 13.5 11.7227 12.7227 11.5 12.5C11.2773 12.2773 10.5 12 10.5 12L6.5 11L18.7723 5.24061L13.5 18Z" fill="currentColor"/>
	</g>
	<defs>
	<clipPath id="clip0_3356_730">
	<rect width="24" height="24" fill="white"/>
	</clipPath>
	</defs>
	</svg>
	